module.exports = __webpack_public_path__ + "img/user.a9db2d3b.svg";